<template>
  <v-card color="secondary">
    <v-card-title
      :class="current.titleClass"
      v-html="current.title"
    />
    <v-card-text>
      <v-container fluid>
        Carregando...
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        >
        </v-progress-linear>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: "LoaderCard",
    props: {
      current: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
